import React from "react"
import PropTypes from "prop-types"
import { Col, Row } from "reactstrap"

// Locale
import { withTranslation } from "react-i18next"

// Importing components
import FeedbackTable from "./CallFeedbackTable"
import FeedbackChart from "./CallFeedbackChart"

const CallFeedbackReporting = props => {
  return (
    <>
      <Row>
        <Col>
          <div className="mt-2 mb-1">
            <Row>
              <FeedbackChart data={props.data} quickGuide={props.quickGuide} />
            </Row>
            <Row>
              <FeedbackTable
                minRows={0}
                selectedType={props.selectedType}
                data={props.data}
              />
            </Row>
          </div>
        </Col>
      </Row>
    </>
  )
}

CallFeedbackReporting.propTypes = {
  data: PropTypes.any,
  selectedType: PropTypes.any,
  quickGuide: PropTypes.any,
}

export default withTranslation()(CallFeedbackReporting)
